const CategoryActionTypes = {
    SET_CATEGORY_ITEM:'SET_CATEGORY_ITEM',
}

export default CategoryActionTypes